import { NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { Confirmation } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialog } from "primeng/confirmdialog";

export type ConfirmDialogVariant = "info" | "danger" | "success" | "warn";

export type ConfirmDialogMessage = Confirmation & {
  severity?: ConfirmDialogVariant;
};

@Component({
  selector: "yt-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrl: "./confirm-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmDialog, ButtonModule, NgClass],
})
export class ConfirmDialogComponent {
  readonly dialogKey = input.required<string>();

  readonly severity = input<ConfirmDialogVariant>("warn");

  readonly iconStyleClass = computed(
    () => `app-confirm-icon-${this.severity()}`,
  );
}
